(function($) {
	$(document).ready(function() {
        initialise();
    });

    function initialise() {
        // GPDR cookie popup
        // ----------
        var gpdr_cookie = getCookie("gdpr-agreement");
        var gpdr_date_changed = new Date(2022, 06, 01);
        var gpdr_max_date = gpdr_date_changed.setYear(gpdr_date_changed.getFullYear() + 1);
        var gpdr_current_date = !Date.now ? 0 : Date.now();

        if(gpdr_cookie == null && gpdr_max_date >= gpdr_current_date) {
            $(".gpdr-agreement").removeClass("gpdr-hide");

            $(".gpdr-agreement > a").bind("click", function(e) {
                e.preventDefault();
                $(".gpdr-agreement").addClass("gpdr-hide");
                setCookie("gdpr-agreement", 1, 360);
            });
        }

        setAmountText();

        setMinimumAmount();


        document.addEventListener('wpcf7mailsent', contactFormRedirection, false);

        $(document).on('blur', '.custom-donation-input', function(){
            setMinimumAmount();
        });

        $(document).on('click', '.village-devise-button', function(){
            const params = new URLSearchParams(window.location.search)
            $('.village-devise-button').removeClass('selected');
            $(this).addClass('selected');
            $.ajax({
                type: 'POST',
                url: '/wp-admin/admin-ajax.php',
                data: {
                  action: 'village_change_devise',
                  id: $(this).attr('id'),
                  co2: params.has('co2') ? params.get('co2') : '',
                },
                success: function(data) {
                  if (data) {
                    $('#village_don').html(data);
                    if(params.has('co2')){
                        setAmountText();
                        $('li.custom-donation-amount .description').html($('#co_text').val());
                        var price = parseFloat($('.village-devise-button.selected').attr("data-price")) * parseFloat(params.get('co2'));
                        $('.custom-donation-input').val(price.toFixed(2));
                        $('li.custom-donation-amount').click();
                        setMinimumAmount();
                    }
                  }
                }
            });
        });
        $(document).on('click', '.donation-amount', function(){
            if($(this).hasClass('custom-donation-amount')){
                $('.suggested-donation-amount input[type=radio]').prop('checked', false);
            }
            $('.donation-amount').removeClass('selected');
            $(this).addClass('selected');
        });

        // filter items on button click
        $('.filter-button-group').on( 'click', 'li', function() {
            var filterValue = $(this).attr('data-filter');
      
            $('.filter-button-group li').removeClass('active');
            $(this).addClass('active');
        });

        if($('.slides-container-projects').length > 0) {
            $('.slides-container-projects').slick({
                mobileFirst: true,
                arrows: true,
                slidesToShow: 1,
                prevArrow: '<button type="button" class="slick-prev"><span class="hidden">Précédent</span></button>',
                nextArrow: '<button type="button" class="slick-next"><span class="hidden">Suivant</span></button>',
            });
        }

        if($('.cat-list_item').length > 0){
            $('.cat-list_item').on('click', function() {
                $(this).parent().parent().find('.cat-list_item').removeClass('active');
                $(this).addClass('active');
                
                var element = $(this).parent().parent().parent().next().find('.slides-container-projects');

                element.slick('unslick');

                $.ajax({
                  type: 'POST',
                  url: '/wp-admin/admin-ajax.php',
                  dataType: 'html',
                  data: {
                    action: 'filter_projects',
                    category: $(this).data('slug'),
                    actions: element.parent().data('slug'),
                  },
                  success: function(res) {
                    
                    //$('.project-tiles').html(res);
                    if (res) {
                        //$('.project-tiles').slick('slickRemove');
                        
                        element.html(res);
                        element.slick({
                            mobileFirst: true,
                            arrows: true,
                            slidesToShow: 1,
                            prevArrow: '<button type="button" class="slick-prev"><span class="hidden">Précédent</span></button>',
                            nextArrow: '<button type="button" class="slick-next"><span class="hidden">Suivant</span></button>',
                        });
                        
                    } else {
                        element.html('No results found.');
                    }
                   
                  }
                })
              });
        }

        if($('.slides-container').length > 0) {
            $('.slides-container').slick({
                mobileFirst: true,
                arrows: true,
                slidesToShow: 1,
                prevArrow: '<button type="button" class="slick-prev"><span class="hidden">Précédent</span></button>',
                nextArrow: '<button type="button" class="slick-next"><span class="hidden">Suivant</span></button>',
                responsive: [
                    {
                        breakpoint: 767,
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            arrows: true,
                            slidesToShow: 3,
                        }
                    },
                  ]
            });
        }

        if($('.slides-container-employe').length > 0) {
            $('.slides-container-employe').slick({
                mobileFirst: true,
                arrows: true,
                slidesToShow: 1,
                prevArrow: '<button type="button" class="slick-prev"><span class="hidden">Précédent</span></button>',
                nextArrow: '<button type="button" class="slick-next"><span class="hidden">Suivant</span></button>',
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            arrows: true,
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            arrows: true,
                            slidesToShow: 5,
                        }
                    },
                  ]
            });
        }

        if($('.slides-container-bibli').length > 0) {
            $('.slides-container-bibli').slick({
                mobileFirst: true,
                arrows: true,
                slidesToShow: 1,
                prevArrow: '<button type="button" class="slick-prev"><span class="hidden">Précédent</span></button>',
                nextArrow: '<button type="button" class="slick-next"><span class="hidden">Suivant</span></button>',
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            arrows: true,
                            slidesToShow: 3,
                        }
                    },
                  ]
            });
        }

        
    }

    function sameHeight($objects) {
        $(window).bind("resize", {cachedObjects: $objects}, function(e) {
            var $cachedObjects = e.data.cachedObjects;
            sameHeightSet($cachedObjects);
        }).trigger("resize");
    }

    function sameHeightSet($cachedObjects) {
        var max = -1;
        var h = 0;

        $cachedObjects.css({minHeight: 0});
        $cachedObjects.each(function() {
            h = $(this).height();
            max = h > max ? h : max;
        });

        $cachedObjects.each(function() {
            $(this).css({minHeight: max});
        });
    }

    function setMinimumAmount(){
        const params = new URLSearchParams(window.location.search)
        if(params.has('co2')){
            var amount = $('.custom-donation-input').val();
            var price = parseFloat($('.village-devise-button.selected').attr("data-price"));
            if(amount < price || isNaN(amount)){
                $('.custom-donation-input').val(price.toFixed(2));
            }
        }
    }

    function setAmountText(){
        const paramsLoad = new URLSearchParams(window.location.search)
        if(paramsLoad.has('co2') && $('ul.donation-amounts').length){
            $('<p>* ' + strings.minimum_contribution + '</p>').insertAfter('ul.donation-amounts');
        }
    }

     /**
     * Function called on the Contact Form 7 form submission.
     * Redirect to the page selected.
    **/
    function contactFormRedirection(event) {
        console.log("envoi");
        redirectUrl = $('input[name=redirect_url]').val();
    
        if(redirectUrl != undefined) {
            $.urlParam = function (name) {
                var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.search);
                return (results !== null) ? results[1] || 0 : false;
            }
    
            var queryParam = $.urlParam('poste');
            var emailSent = $('#iEmail').val();
    
            if(queryParam) {
                window.location = redirectUrl + "?poste=" + queryParam + "&email=" + emailSent;
            }
            else {
                window.location = redirectUrl;
            }
        }
    }



    // Set cookie information
    //
    // @return Void
    function setCookie(cookie_name, value, expiration_days) {
        var expiration_date = new Date();
        expiration_date.setDate(expiration_date.getDate() + expiration_days);

        var cookie_value = escape(value) + ((expiration_days == null) ? "" : "; expires=" + expiration_date.toUTCString())+"; path=/";
        document.cookie = cookie_name + "=" + cookie_value;
    }

    // Get cookie information
    //
    // @return String || undefined
    function getCookie(cookie_name) {
        var cookie_value = document.cookie;
        var cookie_start = cookie_value.indexOf(" " + cookie_name + "=");

        if (cookie_start == -1) cookie_start = cookie_value.indexOf(cookie_name + "=");

        if (cookie_start == -1) {
        cookie_value = null;
        }else{
        cookie_start = cookie_value.indexOf("=", cookie_start) + 1;
        var c_end = cookie_value.indexOf(";", cookie_start);

        if (c_end == -1) c_end = cookie_value.length;

        cookie_value = unescape(cookie_value.substring(cookie_start,c_end));
        }

        return cookie_value;
    }
})(jQuery);